// extracted by mini-css-extract-plugin
module.exports = {"grid":"NewsPage_grid__2X8g7","grid2":"NewsPage_grid2__2QfQT","grid3":"NewsPage_grid3__2fCvj","grid2_1":"NewsPage_grid2_1__Dj-2s"};